// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { IExceptionTelemetry } from '@microsoft/applicationinsights-web';

export function createException(correlationVector: string, exceptions?: any, errorInfo?: any, handled: boolean = true) {
    // if (exception && typeof(exception) === 'object') {
    //     exception.correlationVector = correlationVector;
    // }

    return {
        id: correlationVector,
        exception: exceptions,
        error: exceptions,
        properties: {
            correlationVector,
            errorInfo,
            handled,
        },
    } as IExceptionTelemetry;
}
